// exaustores.jsx
// Configuração dos exaustores

export const exaustoresConfig = [
  { 
    id: "Exaustor01", 
    descricao: "Exaustor01",
    onCommand: "1V10",  // Ajuste o código conforme seu sistema
    offCommand: "1V00",
  },
  { 
    id: "Exaustor02", 
    descricao: "Exaustor02",
    onCommand: "1W10",
    offCommand: "1W00",
  },
    { 
    id: "Exaustor03", 
    descricao: "Exaustor03",
    onCommand: "1X10",
    offCommand: "1X00",
  },
    { 
    id: "Exaustor04", 
    descricao: "Exaustor04",
    onCommand: "1Y10",
    offCommand: "1Y00",
  },
  // Adicione mais exaustores conforme necessário
];

// Função helper para gerar comandos baseados no número do exaustor
export const generateExaustorCommands = (exaustorNumber) => {
  // Converte número para letra (1=A, 2=B, etc.)
  const letter = String.fromCharCode(64 + exaustorNumber); // 65 é 'A' em ASCII
  return {
    onCommand: `2${letter}10`,  // Usando prefixo "2" para diferenciar de iluminação
    offCommand: `2${letter}00`
  };
};

// Função para obter informações de comando para cada exaustor
export const getExaustorCommands = (exaustorId) => {
  const exaustor = exaustoresConfig.find(
    ex => ex.id === exaustorId || ex.descricao === exaustorId
  );
  
  if (!exaustor) {
    return null;
  }
  
  return {
    descricao: exaustor.descricao,
    onCommand: exaustor.onCommand,
    offCommand: exaustor.offCommand
  };
};

// Função para obter exaustor pelo ID
export const getExaustorById = (id) => {
  return exaustoresConfig.find(ex => ex.id === id);
};

// Função para obter exaustor por número do circuito
export const getExaustorByCircleNumber = (circleNumber) => {
  return exaustoresConfig.find(ex => ex.circleNumber === circleNumber);
};